<template>
  <div @click="toggle" class="ml-steps__item">
    <step :completed="completed" :show="show" @close="toggle">
      <div class="ml-steps-card__title">{{$t("mylist.listPhoto")}}</div>
      <template v-slot:icon>
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.25 4.87502H13.29L13.05 4.12502C12.8944 3.68494 12.6058 3.30414 12.2242 3.03539C11.8425 2.76663 11.3868 2.62322 10.92 2.62502H7.08C6.60866 2.6259 6.1495 2.77478 5.76732 3.05065C5.38515 3.32651 5.09926 3.71543 4.95 4.16252L4.71 4.91252H3.75C3.15326 4.91252 2.58097 5.14957 2.15901 5.57153C1.73705 5.99348 1.5 6.56578 1.5 7.16252V13.1625C1.5 13.7593 1.73705 14.3316 2.15901 14.7535C2.58097 15.1755 3.15326 15.4125 3.75 15.4125H14.25C14.8467 15.4125 15.419 15.1755 15.841 14.7535C16.2629 14.3316 16.5 13.7593 16.5 13.1625V7.16252C16.505 6.8639 16.4505 6.56728 16.3396 6.28996C16.2288 6.01263 16.0638 5.76015 15.8544 5.54723C15.645 5.33431 15.3952 5.16521 15.1198 5.0498C14.8443 4.93439 14.5487 4.87498 14.25 4.87502ZM15 13.125C15 13.3239 14.921 13.5147 14.7803 13.6553C14.6397 13.796 14.4489 13.875 14.25 13.875H3.75C3.55109 13.875 3.36032 13.796 3.21967 13.6553C3.07902 13.5147 3 13.3239 3 13.125V7.12502C3 6.9261 3.07902 6.73534 3.21967 6.59469C3.36032 6.45403 3.55109 6.37502 3.75 6.37502H5.25C5.41355 6.38355 5.5754 6.33832 5.71083 6.24623C5.84625 6.15414 5.94781 6.02025 6 5.86502L6.405 4.63502C6.45531 4.48605 6.55117 4.35667 6.67903 4.26515C6.80688 4.17363 6.96027 4.12461 7.1175 4.12502H10.9575C11.1147 4.12461 11.2681 4.17363 11.396 4.26515C11.5238 4.35667 11.6197 4.48605 11.67 4.63502L12.075 5.86502C12.1231 6.00808 12.2133 6.13328 12.3337 6.22427C12.4542 6.31526 12.5992 6.3678 12.75 6.37502H14.25C14.4489 6.37502 14.6397 6.45403 14.7803 6.59469C14.921 6.73534 15 6.9261 15 7.12502V13.125ZM9 6.37502C8.40666 6.37502 7.82664 6.55096 7.33329 6.88061C6.83994 7.21025 6.45542 7.67879 6.22836 8.22697C6.0013 8.77515 5.94189 9.37835 6.05764 9.96029C6.1734 10.5422 6.45912 11.0768 6.87868 11.4963C7.29824 11.9159 7.83279 12.2016 8.41473 12.3174C8.99667 12.4331 9.59987 12.3737 10.1481 12.1467C10.6962 11.9196 11.1648 11.5351 11.4944 11.0417C11.8241 10.5484 12 9.96836 12 9.37502C12 8.57937 11.6839 7.81631 11.1213 7.2537C10.5587 6.69109 9.79565 6.37502 9 6.37502ZM9 10.875C8.70333 10.875 8.41332 10.787 8.16664 10.6222C7.91997 10.4574 7.72771 10.2231 7.61418 9.94904C7.50065 9.67495 7.47094 9.37335 7.52882 9.08238C7.5867 8.79141 7.72956 8.52414 7.93934 8.31436C8.14912 8.10458 8.41639 7.96172 8.70736 7.90384C8.99834 7.84596 9.29994 7.87567 9.57402 7.9892C9.84811 8.10273 10.0824 8.29499 10.2472 8.54166C10.412 8.78834 10.5 9.07834 10.5 9.37502C10.5 9.77284 10.342 10.1544 10.0607 10.4357C9.77936 10.717 9.39782 10.875 9 10.875Z"
            fill="#424142"
          />
        </svg>
      </template>
      <template v-slot:modal>
        <div class="card-wizard">
          <div class="card-wizard__title">
            <h3 class="header-3">{{ $t("mylist.widgetPhoto") }}</h3>
          </div>
          <form class="card-wizard__form">
            <div class="card-wizard__upload">
              <div class="card-wizard__upload-photo">
                <figure
                  class="card-wizard__figure"
                  v-show="photo !== '' && photo !== null"
                >
                  <img
                    v-show="photo !== ''"
                    :src="photoSrc"
                    width="150"
                    height="150"
                    sizes="150px"
                    alt=""
                  />
                </figure>
                <figure
                  v-show="photo === '' || photo === null"
                  class="card-wizard__figure"
                >
                  <img
                    class="upload-photo__picture"
                    src="../../../assets/img/covers/embarazada-p-500.jpeg"
                    alt=""
                  />
                </figure>

                <div class="card-wizard__upload-mobile">
                  <input
                    type="file"
                    id="photo"
                    name="photo"
                    @change="previewPhoto"
                    accept="image/*"
                    hidden
                  />
                  <label for="photo" class="button button--sm button--block">
                    {{ $t("mylist.widgetPhoto") }}
                  </label>
                </div>

                <div class="bb-form-error" v-if="errorMsg">
                  {{ errorMsg }}
                </div>
                <div class="card-wizard__upload-size">
                  {{ $t("generic.photoMaxSize") }}
                </div>
              </div>
            </div>

            <div class="card-wizard__actions">
              <loading-button v-if="loading"></loading-button>
              <button
                v-else
                class="button button--primary button--block"
                @click.prevent="save"
                :disabled="photoDisabled"
              >
                {{ $t("generic.save") }}
              </button>
            </div>
          </form>
        </div>
      </template>
    </step>
    <alert v-if="showAlertLocal" @retry="retry" :key="key" />
  </div>
</template>

<script>
import Step from "./Step";
import LoadingButton from "../../../components/LoadingButton";
import { mapGetters } from "vuex";
import OwnerListAlert from "./OwnerListAlert";

export default {
  name: "PhotoStep",
  components: {
    Step,
    "loading-button": LoadingButton,
    alert: OwnerListAlert,
  },
  data() {
    return {
      show: false,
      photo: "",
      loading: false,
      errorMsg: null,
      preview: false,
    };
  },
  computed: {
    ...mapGetters({
      list: "ownerList",
      showAlertKey: "showAlertKey",
      showAlert: "showAlert",
    }),
    photoDisabled() {
      return this.photo === '' || this.errorMsg !== null || ! this.photo?.startsWith('data:image')
    },
    photoSrc() {
      return this.preview && this.errorMsg === null
        ? this.photo
        : this.$getUserImgUrl(this.list.photo);
    },
    showAlertLocal() {
      return this.showAlertKey === this.key && this.showAlert;
    },
    key() {
      return "list_photo_step";
    },
    completed() {
      return this.list.photo !== "" && this.list.photo != null && this.list.photo !== "default-profile-image.jpg";
    },
  },
  methods: {
    async retry() {
      this.$store.commit("setAlertRetrying", true);
      await this.save();
      this.$store.commit("setAlertRetrying", false);
    },
    previewPhoto(event) {
      this.preview = true;
      var input = event.target;
      this.errorMsg = null;
      if (input.files && input.files[0]) {
        const maxAllowedSize = 4 * 1024 * 1024;
        if (input.files[0].size > maxAllowedSize) {
          this.errorMsg = this.$t("mylist.widgetPhotoErrorToWeight");
          input.value = "";
          return;
        }
        var reader = new FileReader();
        reader.onload = (e) => {
          this.photo = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    toggle() {
      this.show = !this.show;
    },
    async save() {
      this.loading = true;
      try {
        var image = this.photo
          .replace("data:image/png;base64,", "")
          .replace("data:image/jpeg;base64,", "");
        await this.$store.dispatch('setUserImage',{ content: image })
      } catch {
        this.loading = false;
        this.show = false;
        this.preview = false;
        this.$alert.error(
          this.$t("mylist.widgetPhotoError"),
          true,
          this.key
        );
        this.errorMsg = null;
        return;
      }
      this.$alert.success(
        this.$t("mylist.widgetPhotoSuccess"),
        this.key
      );
      this.loading = false;
      window.mixpanel.track("Onboarding", {
        "Step Name": "Step 2: Child Name",
        Skipped: false,
        "Last O Slide": false,
        "On Seq Com": false,
      });
      window.mixpanel.people.increment("Steps Taken");
      this.show = false;
      this.preview = false;
      this.errorMsg = null;
    },
  },
  mounted() {
    this.photo = this.list.photo;
  },
};
</script>
